// import { Link } from 'react-router-dom';
import Footer from '../components/Footer.js';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
    //Form Variables
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isPending, setIsPending] = useState(false)
    const navigate = useNavigate();
    const base_url = process.env.REACT_APP_BASE_URL;
    //toasts for failed password notification=====================
    const loginFail = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsPending(true)

        // Make axios POST request to add data to the database
        axios.post(`${base_url}/auth/admin-login`, {
            "email": email,
            "password": password
        })
            .then(function (response) {
                console.log(response.data)
                sessionStorage.setItem("email", email);
                sessionStorage.setItem("password", password);
                sessionStorage.setItem("token", response.data.token);
                sessionStorage.setItem("userType", response.data.userD.userType);
                navigate("/users");
            })
            .catch(function (error) {
                console.log(error.response)
                if (error.response !== undefined) {
                    console.log(error.response.data.msg);
                    loginFail("Error! " + error.response.data.msg);
                    setIsPending(false)
                }
                else if (error.response === undefined) {
                    loginFail("Sorry a Network Error occurred while trying to log you in. Please try again");
                    setIsPending(false)
                }
            });
    }
    return (
        <>
            <div className="bg-pattern">
                {/* <Navbar /> */}
                <br /><br />
                <ToastContainer />
                <div className="container my-5">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-2 col-lg-4">
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-8 col-lg-4">
                            <center>
                                <h5 className="bold text-custom">CORPER INVEST DASHBOARD</h5>
                            </center>
                            <div className="login-container px-4 py-5 shadow container-radius">
                                <div className="text-center">
                                    <h4 className="section-title">Admin Login</h4>
                                    <small className="login-caption">
                                        For your security, please keep your login details safe and secure.
                                    </small>
                                </div>

                                <form onSubmit={handleSubmit} className="mt-3">
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i className="bi bi-envelope"></i></span>
                                        <input type="email" className="form-control custom-input-group" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
                                    </div>
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i className="bi bi-person-lock"></i></span>
                                        <input type="password" className="form-control custom-input-group" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required />
                                    </div>
                                    {
                                        isPending ?
                                            (
                                                <button className="btn-custom w-100 mt-3 btn-disabled" disabled>
                                                    Logging in
                                                    <div className="spinner-border spinner-border-sm text-light ms-2"></div>
                                                </button>
                                            ) :
                                            (
                                                <button className="btn-custom w-100 mt-3">Log In</button>
                                            )
                                    }
                                    <br /><br />
                                </form>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-2 col-lg-4"></div>
                    </div>
                </div>
                <br/><br/>
                <Footer />
            </div>

        </>

    )
}

export default Login;